import { QuoteActionType } from '@features/invoices/enums/quoteActionType'

export enum QuotesTableStaticActionType {
  ChangeStatus = 'changeStatus',
  ConvertToDepositInvoice = QuoteActionType.ConvertToDepositInvoice,
  ConvertToFinalInvoice = QuoteActionType.ConvertToFinalInvoice,
  ConvertToInvoice = QuoteActionType.ConvertToInvoice,
  Delete = QuoteActionType.Delete,
  Download = 'download',
  Duplicate = QuoteActionType.Duplicate,
  Edit = QuoteActionType.Edit,
  MarkAsSent = QuoteActionType.MarkAsSent,
  MarkAsUnsent = QuoteActionType.MarkAsUnsent,
  SendByEmail = QuoteActionType.SendByEmail,
  ViewLinkedInvoice = 'viewLinkedInvoice',
}
